import Vue from 'vue'

import {firebase} from "../firebase-int";
import { getFirestore, collection, addDoc, serverTimestamp  } from "firebase/firestore/lite"
const firestore = getFirestore(firebase);
// Vue.mixin({
//     methods: {
//       globalHelper: function () {
//         alert("Hello world")
//       },
//     },
//   })
export default {
  data() {
    return {
      
      //if in production
      //subDirectory:"/gebi/",
      //serverUrl:"https://gebi-server.addisapps.com",
      //routeSubDirectory:"/gebi",

      //if on local machine
      subDirectory:"/",
      serverUrl:"http://localhost:3000",
      routeSubDirectory:"",
    }
  },
  methods: {
    async addToLog(message, addedBy, addedAbout) {
      try {
        
            const docRef = await addDoc(collection(firestore, "log"), {
              message: message,
              addedBy:addedBy,
              addedAbout:addedAbout,
              timestamp:serverTimestamp()
            });
            console.log("Log: Document written with ID: ", docRef.id);
          } catch (e) {
            console.error("Error adding document: ", e);
          }
  
      },

      getBaseUrl()
      {
        const baseUrl="http://localhost:3000";
        console.log("Base Url:  ", baseUrl);
        return baseUrl;
      },

      getCurrentUSer()
      {
          // return getSavedState('auth.currentUser').username;
          return JSON.parse(window.localStorage.getItem('currentUser')).username;
      },
      getStyle() {
        if (this.$i18n.locale == 'am') return 'lighterTextAm'
        else return 'lighterTextEn'
      },
      getSmallStyle() {
        if (this.$i18n.locale == 'am') return 'lighterTextSmallAm'
        else return 'lighterTextSmallEn'
      },
      getSmallButton(){
        if (this.$i18n.locale == 'am') return 'btnSmallAm'
        else return 'btnSmallEn'
      },
      compare(a, b) {
        if (a.name < b.name)
          return -1;
        if (a.name > b.name)
          return 1;
        return 0;
      },
      comparePoints(a, b) {
        if (a.points < b.points)
          return 1;
        if (a.points > b.points)
          return -1;
        return 0;
      },
      compareFirstName(a, b) {
        if (a.firstName < b.firstName)
          return -1;
        if (a.firstName > b.firstName)
          return 1;
        return 0;
      },
      compareFatherName(a, b) {
        if (a.fatherName < b.fatherName)
          return -1;
        if (a.fatherName > b.fatherName)
          return 1;
        return 0;
      },
      compareGrandFatherName(a, b) {
        if (a.grandFatherName < b.grandFatherName)
          return -1;
        if (a.grandFatherName > b.grandFatherName)
          return 1;
        return 0;
      },
      
    scrollToElement(elementId) {
      let element = document.getElementById(elementId);
      /* element.scrollIntoView({ behavior: "smooth", block: "start" }); */
      let dims = element.getBoundingClientRect();
      window.scrollTo(window.scrollX, dims.top);
    },
  },

  // getUsers: async function()
  // {
  //     members=[];
  //   const q = query(collection(firestore, "member"));
  //   const querySnapshot = await getDocs(q);
  //   querySnapshot.forEach((doc) => {
  //     var tempPassword=CryptoJS.AES.decrypt(doc.data().password,'123#$%').toString(CryptoJS.enc.Utf8);
  //     console.log('temp password: '+tempPassword);
  //     doc.data().password.password=tempPassword;
  //     doc.data().username=CryptoJS.AES.decrypt(doc.data().contactNumber,'123#$%').toString(CryptoJS.enc.Utf8);
  //     members.push(doc.data());
      
  //   });
  //   return members;
  //   //console.log("Entrered Password => " + password);
  // }
};